import { action } from 'sky-engine/api/index'

import { NPS } from '@/api/apiModules'

export function createNps(data) {
  return action(NPS, 'create', data)
}

export function findNeedNps(data) {
  return action(NPS, 'findNeedNpsLog', data)
}

export function clearLog(data) {
  return action(NPS, 'clearLog', data)
}
